var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeapLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_19531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4311 22.4937C32.4311 27.6703 26.1473 29.775 18.3389 29.775C10.5306 29.775 4.15527 27.6703 4.15527 22.4937C4.15527 17.3171 10.4849 13.1206 18.2932 13.1206C26.1015 13.1206 32.4311 17.3171 32.4311 22.4937Z",
    fill: "#1F7F58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9903 11.1992C30.9898 10.1817 30.6752 9.18925 30.0896 8.35728C29.5039 7.5253 28.6757 6.8944 27.718 6.55073C26.7604 6.20705 25.72 6.16736 24.739 6.43708C23.7579 6.7068 22.8841 7.27278 22.2367 8.05772C19.6559 7.48793 16.9818 7.48793 14.4009 8.05772C13.6145 7.09941 12.4966 6.4717 11.269 6.29911C10.0414 6.12653 8.79374 6.42168 7.77358 7.12601C6.75341 7.83035 6.03526 8.89241 5.76158 10.1015C5.4879 11.3106 5.67869 12.5784 6.2961 13.6534C5.89927 14.4878 5.69178 15.3996 5.68849 16.3236C5.68849 21.125 11.3427 25.0168 18.3165 25.0168C25.2903 25.0168 30.9446 21.125 30.9446 16.3236C30.9417 15.3996 30.7342 14.4877 30.337 13.6534C30.7663 12.9068 30.9916 12.0604 30.9903 11.1992Z",
    fill: "#29A874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1955 13.9443C11.8633 13.9443 13.2153 12.5923 13.2153 10.9245C13.2153 9.25677 11.8633 7.90479 10.1955 7.90479C8.52777 7.90479 7.17578 9.25677 7.17578 10.9245C7.17578 12.5923 8.52777 13.9443 10.1955 13.9443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3 13.9443C27.9678 13.9443 29.3198 12.5923 29.3198 10.9245C29.3198 9.25677 27.9678 7.90479 26.3 7.90479C24.6323 7.90479 23.2803 9.25677 23.2803 10.9245C23.2803 12.5923 24.6323 13.9443 26.3 13.9443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57994 29.4092C8.73319 29.4093 8.88474 29.3771 9.0247 29.3147C9.16467 29.2523 9.28991 29.1611 9.39224 29.0471C9.49457 28.933 9.57169 28.7986 9.61857 28.6527C9.66545 28.5068 9.68103 28.3527 9.66431 28.2003C9.40992 25.9319 8.28163 21.0179 3.33198 18.0622C-3.25657 14.1274 1.95937 27.6705 1.95937 27.6705L0.596819 28.4557C0.499198 28.5117 0.422815 28.5984 0.379548 28.7022C0.336281 28.8061 0.328552 28.9214 0.357564 29.0302C0.386577 29.1389 0.450704 29.235 0.539976 29.3036C0.629248 29.3721 0.738663 29.4092 0.85121 29.4092H8.57994Z",
    fill: "#29A874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2461 29.4092C27.6586 29.4092 27.1992 28.8455 27.2651 28.2003C27.4957 25.9319 28.5151 21.0179 32.9889 18.0622C38.9442 14.1274 34.2297 27.6705 34.2297 27.6705L35.4614 28.4557C35.8714 28.7164 35.7039 29.4092 35.2308 29.4092H28.2461Z",
    fill: "#29A874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1955 11.4736C10.4988 11.4736 10.7446 11.2278 10.7446 10.9245C10.7446 10.6213 10.4988 10.3755 10.1955 10.3755C9.8923 10.3755 9.64648 10.6213 9.64648 10.9245C9.64648 11.2278 9.8923 11.4736 10.1955 11.4736Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3 11.4736C26.6033 11.4736 26.8491 11.2278 26.8491 10.9245C26.8491 10.6213 26.6033 10.3755 26.3 10.3755C25.9968 10.3755 25.751 10.6213 25.751 10.9245C25.751 11.2278 25.9968 11.4736 26.3 11.4736Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_19531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 23.5175,
    fill: "white",
    transform: "translate(0 6.25781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeapLogo);
export default __webpack_public_path__ + "static/media/leap-logo.941f909883c2112db35ff79afc80c8f6.svg";
export { ForwardRef as ReactComponent };